import { Helmet } from 'react-helmet-async';
import RecordsClientV2 from '../components/records/RecordsClientV2';

export default function RecordsPage() {

  return (
    <>
      <Helmet>
        <title>Dental Records - Doctif</title>
        <meta
          name="description"
          content="Interactive dental charting, NGAP treatment management, and comprehensive patient records."
        />
      </Helmet>

      <RecordsClientV2 />
    </>
  );
}
